import { connect, ConnectedProps } from 'react-redux';
import { fetchCards } from '../../actions/fetchCards';
import { showCardAddedMessage } from '../../actions/ui';
import { selectAppSessionId, selectViewMode } from '../../selectors/appState';
import { selectDeviceType } from '../../selectors/deviceType';
import { IStoreState } from '../../types/StoreState';
import { AddPaymentMethodButtonController } from './controller';

const mapStateToProps = (state: IStoreState) => ({
  viewMode: selectViewMode(state),
  deviceType: selectDeviceType(state),
  appSessionId: selectAppSessionId(state),
});
const mapDispatchToProps = {
  fetchCards,
  showCardAddedMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AddPaymentMethodButtonConnectedProps = ConnectedProps<typeof connector>;
export const AddPaymentMethodButton = connector(AddPaymentMethodButtonController);
